const home = {
  'hero.eyebrow': 'USFANS SPREADSHEET RESOURCE HUB',
  'hero.title': 'USFans Spreadsheet — Find, Compare & Research USFans Resources',
  'hero.description': 'Explore USFans spreadsheet resources, seller guides, product research, shipping information, warehouse guides, reviews, coupons, safety tips and practical buying resources — organized in one easy-to-use hub.',
  'hero.btnSpreadsheet': 'USFans Spreadsheet',
  'hero.btnBuyNow': 'Buy It Now',
  'hero.dropdownLabel': 'Browse categories',
  'hero.popular': 'Popular searches:',

  'category.title': 'Browse USFans Categories',
  'category.subtitle': 'Pick a category to explore curated USFans resources and head straight to the main website.',
  'category.browseAll': 'Browse all categories',

  'about.title': 'What Is the USFans Spreadsheet?',
  'about.p1': 'The USFans spreadsheet is a shared resource that collects product links, seller notes, pricing hints and category shortcuts from the USFans community. Instead of digging through scattered posts, buyers and sellers use it as a single starting point for research.',
  'about.p2': 'It works as a living directory: entries are grouped by category, updated over time, and paired with direct links to the main website. This hub mirrors that structure so you can jump into the exact section you need without extra clicks.',

  'article.title': 'Featured Guides',
  'article.subtitle': 'Original, practical guides to help you research the USFans spreadsheet safely.',
  'article.cardTitle': 'USFans Spreadsheet: Complete Guide',
  'article.cardExcerpt': 'Everything you need to know about the USFans spreadsheet — how it works, how to use categories, what to check before buying and the safety basics every buyer should follow.',
  'article.readMore': 'Read the guide',

  'review.title': 'USFans Review at a Glance',
  'review.p1': 'Most USFans users value the spreadsheet for its organized layout and quick category access. The strongest feedback centers on time saved during product research, while the most common caveat is to double-check shipping details before checkout.',
  'review.p2': 'Treat the spreadsheet as a research aid, not a guarantee. Cross-check seller notes and prices on the main website, and keep your own checklist for the products that matter most to you.',

  'shipping.title': 'USFans Shipping Cost',
  'shipping.p1': 'Shipping costs vary by item weight, destination and the seller\'s warehouse location. The spreadsheet groups products by category, which makes it easier to compare similar items and estimate what shipping might add to your total.',
  'shipping.p2': 'Always confirm the final shipping price on the main website before placing an order, since rates can change with promotions, region and package size.',

  'safety.title': 'Is USFans Safe & Legit?',
  'safety.p1': 'USFansLink is an independent informational resource — we are not the official USFans website. Our goal is to help you research safely. Verify URLs, read seller notes and avoid sharing payment details outside trusted channels.',
  'safety.p2': 'For peace of mind, complete any purchase on the main website through its official checkout, and keep records of your orders and conversations with sellers.',

  'faq.title': 'Frequently Asked Questions',
  'faq.q1': 'Is USFansLink the official USFans website?',
  'faq.a1': 'No. USFansLink is an independent resource hub. We collect and organize links and guides, but all purchases happen on the main website.',
  'faq.q2': 'How do I use the category dropdown?',
  'faq.a2': 'Open the dropdown, choose a category, and you will be taken directly to the matching section on the main website.',
  'faq.q3': 'Where can I find shipping and coupon information?',
  'faq.a3': 'Shipping details, coupons and discount codes are updated by the main website. We point you to the right category and recommend confirming the final price before checkout.',
  'faq.q4': 'Do you sell products directly?',
  'faq.a4': 'No. We do not sell or ship any products. All orders are handled by the main website.',

  'cta.title': 'Ready to Explore USFans Spreadsheet Resources?',
  'cta.subtitle': 'Browse the categories below or head straight to the main website to start your research.',
  'cta.btnExplore': 'Explore Spreadsheet',
  'cta.btnVisit': 'Visit Main Website',

  'pillar.title': 'Pillar Articles',
  'pillar.subtitle': 'Ten original, in-depth guides covering every core USFans spreadsheet topic — read from the top and jump back anytime.',
  'pillar.read': 'Read article',
  'pillar.spreadsheet.title': 'USFans Spreadsheet: Complete Guide',
  'pillar.spreadsheet.excerpt': 'How the spreadsheet works, how to use categories, and what to check before buying.',
  'pillar.review.title': 'USFans Review 2026',
  'pillar.review.excerpt': 'What users say, the pros and cons, and what to know before you start.',
  'pillar.shipping.title': 'USFans Shipping Cost Guide',
  'pillar.shipping.excerpt': 'How shipping is priced, what affects the total, and how to estimate costs.',
  'pillar.coupon.title': 'USFans Coupon & Discount Code',
  'pillar.coupon.excerpt': 'Where to find codes, how to check them, and how to avoid fake deals.',
  'pillar.warehouse.title': 'USFans Warehouse Guide',
  'pillar.warehouse.excerpt': 'How the warehouse process works and what it means for dispatch times.',
  'pillar.legit.title': 'Is USFans Legit? Safety Guide',
  'pillar.legit.excerpt': 'URL checks, phishing warnings and the safety habits for secure research.',
  'pillar.product.title': 'USFans Product Research Guide',
  'pillar.product.excerpt': 'How to compare listings, check details, and spot a fair price.',
  'pillar.seller.title': 'USFans Seller Research Guide',
  'pillar.seller.excerpt': 'How to evaluate sellers and keep useful notes on your orders.',
  'pillar.qc.title': 'USFans QC Guide',
  'pillar.qc.excerpt': 'What to look for in images, descriptions and seller feedback.',
  'pillar.buying.title': 'USFans Buying Guide',
  'pillar.buying.excerpt': 'A simple checklist to follow before you place an order.',
};

export default home;